import { service } from "@/utils/request";
export default {
  // 微页面分页列表
  getMiniPageList(params) {
    return service({
      url: "/cloud/activity/micro/list",
      method: "get",
      params
    });
  },
  // 微页面详情
  getMiniPageDetail(id) {
    return service({
      url: `/cloud/activity/micro/detail/${id}`,
      method: "get"
    });
  },
  // 更新微页面
  updateMiniPage(data) {
    return service({
      url: "/cloud/activity/micro/update",
      method: "post",
      data
    });
  },
  // 删除微页面
  deleteMiniPage(id) {
    return service({
      url: `/cloud/activity/micro/delete/${id}`,
      method: "post"
    });
  },
  // 添加微页面
  addMiniPage(data) {
    return service({
      url: `/cloud/activity/micro/add`,
      method: "post",
      data
    });
  },
  // 微页面用户列表
  getMiniUserList(params) {
    return service({
      url: `/cloud/activity/micro/visit/list`,
      method: "get",
      params
    });
  },
  // 微页面用户列表导出
  exportMiniUserList(pageId) {
    return service({
      url: `/cloud/activity/micro/visit/list/export`,
      method: "get",
      params: { pageId },
      responseType: 'blob'
    });
  },
};


// WEBPACK FOOTER //
// ./src/api/operateManage/miniPage.js